import { useMemo } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import Auth from '@nordvpn/teams.core/lib/auth';
import { isLoggedIn } from '@nordvpn/teams.core/lib/auth/utils/localStorage';
import { sidebarItems } from 'components/molecules/LeftSidebar/constants';
import { STORAGE_NAME_AUTH } from 'pages/LoginOld/constants';
import { getAvailableRedirectPath } from 'utils/routing/getAvailableRedirectPath';
import { getPathWithRegion, getRegionFromSearch } from 'utils/routing/regionAvailability';
import { useAccount } from 'api/Account/queries';
/**
 * Redirects to the first available path from the sidebarItems list based on the user's permissions.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export var RedirectByPermission = function RedirectByPermission() {
    var _useLocation = useLocation(), search = _useLocation.search;
    var loggedIn = isLoggedIn(STORAGE_NAME_AUTH);
    var _useAccount = useAccount({
        enabled: loggedIn
    }), account = _useAccount.data;
    var _ref = account !== null && account !== void 0 ? account : {}, permissions = _ref.permissions;
    var region = getRegionFromSearch(search);
    var redirectPath = useMemo(function () {
        return getPathWithRegion(getAvailableRedirectPath(sidebarItems, permissions !== null && permissions !== void 0 ? permissions : []), region);
    }, [permissions, region]);
    return /*#__PURE__*/ _jsx(Redirect, {
        to: loggedIn ? redirectPath : Auth.constants.LOGIN
    });
};
